import React, { Component } from 'react'
import update from 'react/lib/update';
import PropTypes from 'prop-types'
import Radium from 'radium';
import Row from './table/row'
import Cell from './table/cellTextarea'
import Header from './table/header'
import { semanticColors } from '../../../../Globals/styles';

const propTypes = {}

const defaultProps = {}

class Offers extends Component {
    constructor(props) {
        super(props)
        this.state = {
            width: [
                '5%',
                '45%',
                '10%',
                '10%',
                '10%',
                '10%',
                '10%',
            ]
        }
    }
    shouldComponentUpdate(nextProps) {
        if (this.props.offersKey === nextProps.offersKey) { return false }
        return true
    }
    renderHeader = () => {
        return (
            <Row
            >
                <Header
                    content={'Pos.'}
                    style={{ width: this.state.width[0] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Aktivitet'}
                    style={{ width: this.state.width[1] }}
                />
                <Header
                    content={'Enhed'}
                    style={{ width: this.state.width[2] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Udført'}
                    style={{ width: this.state.width[3] }}
                    inputStyle={{ textAlign: 'center' }}
                />
                <Header
                    content={'Pris'}
                    style={{ width: this.state.width[4] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Tillæg %'}
                    style={{ width: this.state.width[5] }}
                    inputStyle={{ textAlign: 'center' }}
                />
                <Header
                    content={'Sum'}
                    style={{ width: this.state.width[6] }}
                    inputStyle={{
                        textAlign: 'center',
                        paddingRight: 5,
                    }}
                />
            </Row>
        )
    }
    updateFunction = (key, value, obj) => {
        obj[key] = value
        this.props.update(obj.function, obj)
    }
    handleDotAndCommaNumber(input) {
        if (input.indexOf('.') > -1 && input.indexOf(',') > -1) {
            input = input.replace('.', '')
        }
        input = input.replace('.', ',')
        return input
    }

    calcSum = (en, to) => {
        let sum = parseFloat(en.replace(',', '.')) * parseFloat(to.replace(',', '.'))
        if (sum) {
            sum = sum.toFixed(2).replace('.00', '').replace('.', ',')
        }
        return sum
    }

    renderContent = (r, index) => {
        let background = index % 2 == 0 ? semanticColors.mainBackground2 : semanticColors.primaryLight
        let sum = this.calcSum(r[3], r[4])
        sum = (((sum ? parseFloat(sum.toString().replace(',', '.')) : 0) * (((r[7] ? parseFloat(r[7].toString().replace(',', '.')) : 0) / 100) + 1) * 100) / 100).toFixed(2).toString().replace('.00','').replace('.', ',')
        return (
            <Row
                key={index}
            >
                <Cell
                    onChange={(value) => this.updateFunction(0, value, r)}
                    content={r[0]}
                    style={{ width: this.state.width[0] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    onChange={(value) => this.updateFunction(1, value, r)}
                    content={r[1]}
                    style={{ width: this.state.width[1] }}
                    inputStyle={{
                        backgroundColor: background
                    }}
                />
                <Cell
                    onChange={(value) => this.updateFunction(2, value, r)}
                    content={r[2]}
                    style={{ width: this.state.width[2] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',

                    }}
                />
                <Cell
                    onChange={(value) => this.updateFunction(3, value, r)}
                    content={r[3]}
                    style={{ width: this.state.width[3] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    onChange={(value) => this.updateFunction(4, value, r)}
                    content={r[4]}
                    style={{ width: this.state.width[4] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    onChange={(value) => this.updateFunction(7, value, r)}
                    content={r[7]}
                    style={{ width: this.state.width[5] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    readOnly
                    content={sum ? sum : ''}
                    style={{ width: this.state.width[6] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                        paddingRight: 5,
                    }}
                />
            </Row>
        )
    }
    render() {
        let total = 0
        let rows = this.props.rows.map((r, index) => {
            let sum = this.calcSum(r[3], r[4])
            if (sum) {
                sum = (((sum ? parseFloat(sum.toString().replace(',', '.')) : 0) * (((r[7] ? parseFloat(r[7].toString().replace(',', '.')) : 0) / 100) + 1) * 100) / 100).toFixed(2).toString().replace('.', ',')                
                total += parseFloat(sum.replace(',', '.'))
            }
            return this.renderContent(r, index)
        })

        return (
            <div style={[{ width: '100%' }]}>
                {this.renderHeader()}
                {rows}
                <div style={{ float: 'right', padding: 5, borderBottom: '1px solid ' + semanticColors.primaryLight }}>
                    <div style={{ fontWeight: 600 }}>
                    I alt: {total.toFixed(2).toString().replace('.00','').replace('.', ',')}
                    </div>
                </div>
            </div>
        )
    }
}

const styles = {
    flexify: {
        display: 'flex',
        flexDirection: 'row',
    },
    column: {
        flexGrow: 0,
        flexShrink: 0,
        verticalAlign: 'top',
    }
}

Offers.propTypes = propTypes

Offers.defaultProps = defaultProps

export default Radium(Offers)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Invoice/spreadsheets/others.js